export default __webpack_public_path__ + "static/media/empty-node.9547b32d.png";